module.exports = __webpack_public_path__ + "img/OurJourney2022.7d05d717.png";